import {Component, Inject, OnDestroy, OnInit, ViewChild, AfterViewInit,  inject,signal, Signal} from '@angular/core';
import {RevenueRestService} from '../../../../core/services/api/revenue-rest.service';
import {UserService} from '../../../../core/services/user.service';
import {takeUntil} from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';
import {RevenueResponseInterface} from './interface/revenue-response.interface';
import {GlobalConstants} from '../../../../core/constants/global.constants';
import {InternalUserAuthority} from '../../../../core/models/enums/internal-user-authority.model';
import {MatTabGroup} from '@angular/material/tabs';
import {JsonToPdfService} from '../../../../core/services/json-to-pdf.service';
import { EChartsCoreOption } from 'echarts/core';
import {MatomoService} from "../../../../core/services/matomo.service";
import {GoLiveService} from "../../../../core/services/go-live.service";


@Component({
  selector: 'my-sales',
  templateUrl: './my-sales.component.html',
  styleUrls: ['./my-sales.component.scss'],
  standalone: false
})
export class MySalesComponent implements OnInit, OnDestroy, AfterViewInit {
  public revenue: RevenueResponseInterface;
  public idfs$: Observable<any[]>;
  public currentlyDisplayedIdf: string;
  protected currentApothekeName: string;
  public options: EChartsCoreOption;
  public chart;
  public echartsInstance;
  public echartsInstancePkp;
  public loading = true;
  public ngUnsubscribe$ = new Subject<void>();
  public input = false;
  public mainIdf: string;
  public today: Date = new Date();
  public digitalPaket = false;
  protected readonly InternalUserAuthority = InternalUserAuthority;
  public pkpRevenue: RevenueResponseInterface;
  public hasPkpRevenue: boolean = false;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  private scrollPosition = 0;
  private scrollHandler: any;
  private goLive = inject(GoLiveService);
  readonly isLive: Signal<boolean> = this.goLive.isLive('dieselPrices');


  constructor(@Inject(RevenueRestService) public revenueApiService: RevenueRestService,
              @Inject(UserService) public userService: UserService,
              @Inject(JsonToPdfService) public jsonToPdfService: JsonToPdfService,
              @Inject(MatomoService) public matomoService: MatomoService,
              @Inject(GlobalConstants) public contants: GlobalConstants) {
    this.input = this.userService.isPhoenixUser() || this.userService.isInternalUser();
    this.scrollHandler = () => {
      this.scrollPosition = window.scrollY;
      this.goLive.register('dieselPrices', new Date('2026-06-01T00:10:00'));
    };

  }


  ngOnInit() {
    this.userService.selectedIdf$.subscribe(idf => {
      if (typeof idf === 'object') {
        this.currentlyDisplayedIdf = idf.idf;
        this.currentApothekeName = idf.name;
        this.digitalPaket = idf.esare;
        this.hasPkpRevenue = idf.pricingGroups && idf.pricingGroups.indexOf(204) > -1;
        this.loadRevenue(this.currentlyDisplayedIdf);
      }
    });
  }

  ngAfterViewInit() {
    window.addEventListener('scroll', this.scrollHandler);

    if (this.tabGroup) {
      this.tabGroup.selectedIndexChange.subscribe((index) => {
        const currentPosition = this.scrollPosition;

        setTimeout(() => {
          window.scrollTo({
            top: currentPosition,
            behavior: 'auto'
          });
        }, 10);
      });
    } else {
      console.warn('tabGroup is not defined in ngAfterViewInit');
    }
  }

  onTabChange() {
    this.scrollPosition = window.scrollY;
  }

  loadRevenues(date) {
    this.onTabChange();
    switch (date.index) {
      case 0:
        this.loadRevenue(this.currentlyDisplayedIdf);
        break;
      case 1:
        this.loadPkpRevenue(this.currentlyDisplayedIdf);
        break;
    }
  }

  public loadRevenue(idf: string) {
    this.loading = true;

    if (idf.length <= 0) {
      idf = this.mainIdf;
    }
    idf = this.formatIdf(idf);
    this.currentlyDisplayedIdf = idf;

    if (idf === this.contants.DUMMY_IDF) {
      this.fakeGraph(idf);
      return;
    }
    this.revenueApiService.requestRevenue(idf).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((res) => {
          this.revenue = res.returnObject as RevenueResponseInterface;
          this.revenue.chart.series[1].name = 'RX-Umsatz inkl HP';
          this.revenue.chart.series[4].name = 'Non-RX-Umsatz';
          const filteredChart = Array.prototype.slice.call(this.revenue.chart.series);
          filteredChart.splice(2, 1);
          filteredChart.splice(0, 1);
          this.options = {
            color: [
              '#009775',
              '#92d400',
              '#393938',
              '#999999',
              '#91c7ae',
              '#749f83',
              '#92d400',
              '#bda29a',
              '#009775',
              '#999999',
              '#c4ccd3'
            ],
            tooltip: {
              trigger: 'axis',
              formatter: this.formatTooltip
            },
            legend: {
              data: [
                {
                  name: 'Non-RX-Umsatz',
                  icon: 'circle',
                  backgroundColor: '#92d400'
                }
                ,
                {
                  name: 'RX-Umsatz inkl HP',
                  icon: 'circle',
                  backgroundColor: '#009775'
                },
                {
                  name: 'HP-Umsatz',
                  icon: 'circle',
                  backgroundColor: '#535353'
                }
              ],
              bottom: -5,
              left: 80,
              itemGap: 35
            },
            grid: {
              left: '3%',
              right: '3%',
              bottom: '10%',
              top: '15%',
              containLabel: true,
            },
            xAxis: {
              axisLabel: {
                fontSize: 16,
                fontFamily: 'Roboto Light',
                color: '#999999',
                padding: [25, 0, 0, 0],
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              type: 'category',
              boundaryGap: false,
              data: this.revenue.chart.xAxis,
              padding: [0, 30, 0, 0]
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: this.formatYAxisLabel,
                fontSize: 16,
                fontFamily: 'Roboto Light',
                color: '#999999',
                padding: [0, 15, 5, 0],
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
            },
            series: filteredChart
          };

          if (this.dataEmpty(this.revenue.chart.series)) {
            this.options.series = [
              {
                name: 'Non-RX-Umsatz',
                type: 'line',
                data: [0],
              },
              {
                name: 'RX-Umsatz',
                type: 'line',
                data: [0],
              },
              {
                name: 'HP-Umsatz',
                type: 'line',
                data: [0],
              }
            ];
          }

          this.loading = false;
        },
        () => {
          this.loading = false;
        });
  }

  public loadPkpRevenue(idf: string) {
    this.revenueApiService.requestPkpRevenue(idf).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((res) => {
          this.pkpRevenue = res.returnObject as RevenueResponseInterface;
          const filteredChart = Array.prototype.slice.call(this.pkpRevenue.chart.series);
          this.options = {
            color: [
              '#009775',
              '#92d400',
              '#393938',
              '#999999',
              '#91c7ae',
              '#749f83',
              '#92d400',
              '#bda29a',
              '#009775',
              '#999999',
              '#c4ccd3'
            ],
            tooltip: {
              trigger: 'axis',
              formatter: this.formatTooltip
            },
            legend: {
              data: [
                {
                  name: 'PKP Brutto-Umsatz',
                  icon: 'circle',
                  backgroundColor: '#92d400'
                },
                {
                  name: 'PKP RX-Umsatz',
                  icon: 'circle',
                  backgroundColor: '#009775'
                },
                {
                  name: 'PKP Non-RX-Umsatz',
                  icon: 'circle',
                  backgroundColor: '#535353'
                }
              ],
              bottom: -5,
              left: 80,
              itemGap: 35
            },
            grid: {
              left: '3%',
              right: '3%',
              bottom: '10%',
              top: '15%',
              containLabel: true,
            },
            xAxis: {
              axisLabel: {
                fontSize: 16,
                fontFamily: 'Roboto Light',
                color: '#999999',
                padding: [25, 0, 0, 0],
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              type: 'category',
              boundaryGap: false,
              data: this.pkpRevenue.chart.xAxis,
              padding: [0, 30, 0, 0]
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: this.formatYAxisLabel,
                fontSize: 16,
                fontFamily: 'Roboto Light',
                color: '#999999',
                padding: [0, 15, 5, 0],
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
            },
            series: filteredChart
          };

          if (this.dataEmpty(this.pkpRevenue.chart.series)) {
            this.options.series = [
              {
                name: 'PKP Brutto-Umsatz',
                icon: 'circle',
                backgroundColor: '#92d400'
              },
              {
                name: 'PKP RX-Umsatz',
                icon: 'circle',
                backgroundColor: '#009775'
              },
              {
                name: 'PKP Non-RX-Umsatz',
                icon: 'circle',
                backgroundColor: '#535353'
              }
            ];
          }

          this.loading = false;
        },
        () => {
          this.loading = false;
        });
  }

  formatYAxisLabel(value) {
    return value.toLocaleString('de-DE') + '€';
  }

  formatTooltip(params, ticket, callback) {
    let res = params[0].name;
    for (let i = 0, l = params.length; i < l; i++) {
      res += '<br/>' + params[i].marker + params[i].seriesName + ': ' + params[i].value.toLocaleString('de-DE', {
        style: 'currency',
        currency: 'EUR'
      });
    }
    return res;
  }

  formatIdf(idf) {
    return ('0000000' + idf).slice(-7);
  }

  dataEmpty(series) {
    for (const data of series) {
      if (data.data.length) {
        return false;
      }
    }
    return true;
  }

  fakeGraph(idf) {
    this.options = {
      color: [
        '#009775',
        '#92d400',
        '#393938',
        '#999999',
        '#91c7ae',
        '#749f83',
        '#92d400',
        '#bda29a',
        '#009775',
        '#999999',
        '#c4ccd3'
      ],
      tooltip: {
        trigger: 'axis',
        formatter: this.formatTooltip
      },
      legend: {
        data: [
          {
            name: 'Non-RX-Umsatz',
            icon: 'circle',
            backgroundColor: '#92d400'
          }
          ,
          {
            name: 'RX-Umsatz inkl HP',
            icon: 'circle',
            backgroundColor: '#009775'
          },
          {
            name: 'HP-Umsatz',
            icon: 'circle',
            backgroundColor: '#535353'
          }
        ],
        bottom: 0,
        left: 80,
        itemGap: 35
      },
      grid: {
        left: '3%',
        right: '3%',
        bottom: '10%',
        top: '20%',
        containLabel: true,
      },
      xAxis: {
        axisLabel: {
          fontSize: 16,
          fontFamily: 'Roboto Light',
          color: '#999999',
          padding: [25, 0, 0, 0],
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        type: 'category',
        boundaryGap: false,
        data: ['Jan', 'Feb', 'März', 'April', 'Mai', 'Juni', 'Juli', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
        padding: [0, 30, 0, 0]
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: this.formatYAxisLabel,
          fontSize: 16,
          fontFamily: 'Roboto Light',
          color: '#999999',
          padding: [0, 15, 5, 0],
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
      },
      series: [
        {
          name: 'Non-RX-Umsatz',
          type: 'line',
          data: [120, 132, 101, 134, 90, 230, 210, 120, 132, 101, 134, 90],
        },
        {
          name: 'RX-Umsatz inkl HP',
          type: 'line',
          data: [220, 182, 0, 234, 290, 330, 310, 220, 0, 191, 234, 290],
        },
        {
          name: 'HP-Umsatz',
          type: 'line',
          data: [320, 332.32, 301, 334, 390, 330, 320, 320, 332, 301, 334, 390],
        }
      ]
    };

    this.revenue = {chart: null, month: '', totalRevenue: null, rxPacketValue: null, rxSpanPercent: null};
    this.revenue.totalRevenue = 100;
    const now = new Date();

    this.revenue.month = String(new Date(now.getFullYear(), now.getMonth(), now.getDate()).toLocaleString('de', {month: 'long'}));

    this.loading = false;
  }

  onChartInit(ec) {
    this.echartsInstance = ec;
  }


  onChartInitPkp(ec: any) {
    this.echartsInstancePkp = ec;
  }

  savePdf(type) {
    const title = (type === 'PKP') ? 'PKP Monatlicher Umsatzverlauf' : 'Monatlicher Umsatzverlauf';
    const filename = (type === 'PKP') ? 'PKP_Monatlicher_Umsatzverlauf_' : 'Monatlicher_Umsatzverlauf_';
    const rev = (type === 'PKP') ? this.pkpRevenue.chart : this.revenue.chart;
    const instance = (type === 'PKP') ? this.echartsInstancePkp : this.echartsInstance;
    const filteredChart = Array.prototype.slice.call(rev.series);
    const tableMonths: any = rev.xAxis;
    const imgData = instance.getDataURL({
      pixelRatio: 2,
    });
    const chartWidth = instance.getWidth();
    const chartHeight = instance.getHeight();
    const cols = (type === 'PKP') ? [['Monat', 'PKP Brutto-Umsatz', 'PKP RX-Umsatz', 'PKP Non-RX-Umsatz',]] : [['Monat', 'RX-Umsatz inkl. HP', 'HP-Umsatz', 'Non-RX-Umsatz',]];
    if (type === 'Gesamt') {
      filteredChart.splice(2, 1);
      filteredChart.splice(0, 1);
    }

    const values = this.prepareDataForPdf(tableMonths, filteredChart, true);
    const data: any = {
      rows: values,
      cols: cols,
      fileName: filename + this.currentlyDisplayedIdf,
      title: title,
      idf: this.currentlyDisplayedIdf,
      name: this.currentApothekeName,
    };
    this.jsonToPdfService.revenuePdf(data, imgData, chartHeight, chartWidth);
    this.matomoService.trackEvent('Mein Umsatz', 'Download PDF', type )
  }

  prepareDataForPdf(months, numbers, array: boolean = false) {
    let values: any[] = [];


    for (let i = 0; i < months.length; i++) {
      let data = [];
      numbers.forEach(number => {
        data.push(this.formatYAxisLabel(number.data[i]));
      });
      values.push([...[months[i]], ...data]);
    }
    return values;
  }

  /**
   * Unsubscribe from all subscriptions.
   */
  ngOnDestroy() {
    window.removeEventListener('scroll', this.scrollHandler);
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

}
